import { render, staticRenderFns } from "./CompShareSocialNetworks.vue?vue&type=template&id=64129ee0&scoped=true"
import script from "./CompShareSocialNetworks.vue?vue&type=script&lang=js"
export * from "./CompShareSocialNetworks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64129ee0",
  null
  
)

export default component.exports